import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6be4a566"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_2 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, " "),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "หัวข้อข่าวประชาสัมพันธ์"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, " "),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "วันที่")
  ])
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["data-bs-content"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-newspaper me-2" }, null, -1))
const _hoisted_8 = { class: "fas fa-paperclip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announcements, (announcement, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "row-hover",
                onClick: ($event: any) => (_ctx.selectedClick(announcement.id))
              }, [
                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                _createElementVNode("td", {
                  onClick: _withModifiers(($event: any) => (_ctx.toggleClick(announcement.id)), ["stop","prevent"])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([{far: !announcement.pined, fas: announcement.pined, 'text-warning': announcement.pined }, "fa-star"])
                  }, null, 2)
                ], 8, _hoisted_5),
                _createElementVNode("td", {
                  class: "column-name text-truncate",
                  "data-bs-toggle": "popover-announcement",
                  "data-bs-content": announcement.title
                }, [
                  _hoisted_7,
                  _createTextVNode(_toDisplayString(announcement.title), 1)
                ], 8, _hoisted_6),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("span", _hoisted_8, null, 512), [
                    [_vShow, announcement.attachments.length !== 0]
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.thaiDate(announcement.createdAt)), 1)
              ], 8, _hoisted_4))
            }), 128))
          ])
        ], 512)
      ]))
}